import {
  EExternalUpdaterEvent,
  fireEvent
} from 'utils/generic/event-bus/external';

export const openNativePopup = (alias: string) => {
  fireEvent({
    key: EExternalUpdaterEvent.OPEN_POPUP,
    payload: {
      alias
    }
  });
};
